(function () {
    'use strict';

    angular
        .module('awizApp')
        .config(function ($stateProvider) {
            $stateProvider.state('admin', {
                abstract: true,
                parent: 'app'
            });
        });

})();
